import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseCreatePublicCompanyLeadContractFeeProps {
  publicCompanyLeadId?: string
  onSuccess: () => void
  onError: () => void
}

export const useCreatePublicCompanyLeadContractFee = ({
  publicCompanyLeadId,
  onSuccess,
  onError,
}: UseCreatePublicCompanyLeadContractFeeProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createPublicCompanyLeadContractFee'],
    mutationFn: async (data: { label: string; value: string }) => {
      const lead = {
        contract_attributes: {
          contract_fees_attributes: [
            {
              fee_template_id: data.value,
            },
          ],
        },
      }

      await privateAxios.put(`/funnel/public/leads/${publicCompanyLeadId}`, {
        lead,
      })
    },
    onSuccess,
    onError,
  })
}
